
import { Vue } from "vue-class-component";

export default class PickupTotalPickup extends Vue {}
